import { apiUserFetch } from '..';
import {
  GetGammaRoleMembersRes,
  GetPermissionCatalogRes,
  GetRoleRes,
  GetRolesRes,
  type RoleScopeKind,
  SetRoleScopeBody,
} from './types';

/**
 * The thin call layer over `/user/v1/gamma`'s role-administration API
 * (`gamma-prime-be` branch `feat/GP-3853-permissions-role-engine`,
 * `apps/api/src/contexts/user/docs/global-roles.md`, `gamma-roles.controller.ts`).
 *
 * Kept as a single object behind this module boundary (rather than inlined at
 * each call site) so tests can substitute a fixture via
 * `vi.mock('@/api/gamma-roles/client', ...)`.
 */
export type GammaRolesClient = {
  getCatalog: () => Promise<GetPermissionCatalogRes>;
  getRoles: () => Promise<GetRolesRes>;
  getRole: (_roleId: string) => Promise<GetRoleRes>;
  getRoleMembers: (_roleId: string) => Promise<GetGammaRoleMembersRes>;
  setRoleScope: (_roleId: string, _kind: RoleScopeKind, _body: SetRoleScopeBody) => Promise<void>;
};

export const gammaRolesClient: GammaRolesClient = {
  getCatalog: () => apiUserFetch<GetPermissionCatalogRes>('/gamma/permissions/catalog'),

  getRoles: () => apiUserFetch<GetRolesRes>('/gamma/roles'),

  getRole: (roleId) => apiUserFetch<GetRoleRes>(`/gamma/roles/${encodeURIComponent(roleId)}`),

  getRoleMembers: (roleId) =>
    apiUserFetch<GetGammaRoleMembersRes>(`/gamma/roles/${encodeURIComponent(roleId)}/members`),

  setRoleScope: (roleId, kind, body) =>
    apiUserFetch<void>(`/gamma/roles/${encodeURIComponent(roleId)}/scopes/${kind}`, {
      method: 'PUT',
      body,
    }),
};
